export default "__VITE_ASSET__vQaovdp9__"